<template lang='pug' src='./custom-meet-office.pug'></template>

<script>
import ImgBox from 'components/block/block-img-box/block-img-box'
import { Carousel, Slide } from 'vue-carousel'
import Arrow from './arrow-01.svg'

export default {
  props: ['props'],
  data () {
    return {
      arrow: Arrow
    }
  },
  components: {
    ImgBox,
    Carousel,
    Slide
  }
}
</script>



// WEBPACK FOOTER //
// custom-meet-office.vue?590cdcd8